import React from 'react';
import PropTypes from 'prop-types';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import { url } from '../../../config';
import { PRIMARY_COLOR } from '../../../constants';
import { textStyle, linkText, buttonStyle } from '../../../helpers/getEmailStyles';

class CompletedReservationHost extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      guestName: PropTypes.string.isRequired,
      guestLastName: PropTypes.string.isRequired,
      guestProfilePic: PropTypes.string.isRequired,
    }).isRequired
  };

  render() {
    const bookingTitle = {
      paddingBottom: '20px',
      fontWeight: 'bold',
      fontSize: '20px',
      lineHeight: '25px',
      margin: '0',
      padding: '0',
      textAlign: 'center'

    }
    const profilePic = {
      borderRadius: '999px',
      margin: '0',
      padding: '0',
      lineHeight: '150%',
      borderSpacing: '0',
      width: '125px'
    }
    const userName = {
      color: '#565a5c',
      fontSize: '26px',
      fontWeight: 'bold',
      paddingBottom: '5px',
    }
    const subTitle = {
      color: '#565a5c',
      fontSize: '18px',
      fontWeight: 'bold',
      paddingBottom: '5px',
    }
    const space = {
      paddingBottom: '20px',
    }
    const { content: { reservationId, logo, siteName } } = this.props;
    const { content: { guestName, guestLastName, guestProfilePic } } = this.props;
    let messageURL = url + '/review/write/' + reservationId;
    let imageURL;
    if (guestProfilePic) {
      imageURL = url + '/images/avatar/medium_' + guestProfilePic;
    }

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor="#F7F7F7" logo={logo} siteName={siteName} />
        <div>
          <Table width="100%" >
            <TBody>
              <TR>
                <TD style={textStyle}>
                  <EmptySpace height={20} />
                  <div>
                    {
                      guestProfilePic && <img style={profilePic} src={imageURL} height={125} />
                    }
                  </div>
                  <EmptySpace height={20} />
                  <h1 style={bookingTitle}>
                    Dile a {guestName} lo que te gusto <br />
                    <span> y lo que pueden hacer mejor</span>
                  </h1>
                  <EmptySpace height={20} />
                  <div>
                    {guestName} Acabo de comprobarlo, así que ahora es el momento perfecto para escribir tu reseña.
                  </div>
                  <EmptySpace height={20} />
                  <div>
                    Las reseñas son una parte importante de la comunidad {siteName}. Por favor tómese un momento para proporcionar a su huésped algunos comentarios útiles -
                    solo le tomará unos minutos.
                  </div>
                  <EmptySpace height={50} />
                  <div>
                    <a href={messageURL} style={buttonStyle}>Escribir una reseña</a>
                  </div>
                  <EmptySpace height={40} />
                </TD>
              </TR>
            </TBody>
          </Table>
          <EmptySpace height={50} />
        </div>
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default CompletedReservationHost;



